<template>
  <div class="gp-container scroll-vertical">
    <div class="tile is-ancestor dashboard-container">
      <div class="tile is-parent is-4">
        <tile-basic
          class="is-info"
          title="Summary"
          img="action"
          imgSize="75px"
          headerImg="action"
          :values="summaryValues">
        </tile-basic>
      </div>
      <div class="tile is-parent is-4">
        <tile-basic
          class="is-danger"
          title="Alerting"
          img="alert"
          imgSize="75px"
          headerImg="alert"
          :values="alertingValues">
        </tile-basic>
      </div>
      <div class="tile is-parent is-4">
        <tile-basic
          class="is-blue"
          title="Logging"
          img="log"
          imgSize="75px"
          headerImg="log"
          :values="loggingValues">
        </tile-basic>
      </div>
    </div>

    <collapse-card title="Remote Alerting Collection" :open="false">
      <data-configs-tiles
        :config="action.alertConfig"
        class="tiles-section">
      </data-configs-tiles>
    </collapse-card>

    <collapse-card title="Remote Logging Collection" :open="false">
      <data-configs-tiles
        :config="action.logConfig"
        class="tiles-section">
      </data-configs-tiles>
    </collapse-card>

  </div>
</template>

<script>
import _ from 'lodash';
import mixin from '@/mixins/actions';
import DataConfigsTiles from '@/components/actions/DataConfigsTiles.vue';
import CollapseCard from '@/components/CollapseCard.vue';
import TileBasic from '@/components/TileBasic.vue';

export default {
  name: 'ActionDetails',
  mixins: [mixin],
  components: {
    DataConfigsTiles,
    CollapseCard,
    TileBasic,
  },
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      displayValues: this.keyValues(this.action),
    };
  },
  computed: {
    summaryValues() {
      return [
        _.find(this.displayValues, { label: 'Name' }),
        _.find(this.displayValues, { label: 'Description' }),
        _.find(this.displayValues, { label: 'Created' }),
        _.find(this.displayValues, { label: 'Modified' }),
        _.find(this.displayValues, { label: 'Cache Rentention' }),
      ];
    },
    alertingValues() {
      return [
        _.find(this.displayValues, { label: 'GamePlan Alerting' }),
        _.find(this.displayValues, { label: 'Alerting Endpoints' }),
        _.find(this.displayValues, { label: 'Console Logging Alerts' }),
      ];
    },
    loggingValues() {
      return [
        _.find(this.displayValues, { label: 'GamePlan Logging' }),
        _.find(this.displayValues, { label: 'Logging Endpoints' }),
        _.find(this.displayValues, { label: 'Console Logging Logs' }),
      ];
    },
  },
};
</script>
